import BaseChart from './BaseChart';

/**
 * Progress chart implementation using VChart
 * Supports both linear and circular progress
 */
class ProgressChart extends BaseChart {
  /**
   * Get chart specification for progress chart
   * @returns {Object} Chart specification
   */
  getChartSpecification() {
    const commonConfig = this.getCommonConfig();
    const data = this.prepareData();
    
    // Get progress type (linear or circular)
    const isCircular = this.options.type === 'circular';
    const chartType = isCircular ? 'circularProgress' : 'linearProgress';
    
    // Get progress value
    const value = this.data.value ?? (Array.isArray(this.data) ? this.data[0]?.value : 0);
    const min = this.options.min ?? 0;
    const max = this.options.max ?? 100;
    
    // Calculate percentage
    const percentage = Math.min(Math.max((value - min) / (max - min), 0), 1);
    
    return {
      type: chartType,
      data,
      value: percentage,
      
      // Progress specific styling
      track: {
        style: {
          fill: '#f5f5f5',
          ...this.options.trackStyle
        }
      },
      progress: {
        style: {
          fill: '#1890ff',
          ...this.options.progressStyle
        }
      },
      
      // Circular specific options
      ...(isCircular ? {
        startAngle: this.options.startAngle ?? -Math.PI / 2,
        endAngle: this.options.endAngle ?? Math.PI * 1.5,
        thickness: this.options.thickness ?? 10,
        cornerRadius: this.options.cornerRadius ?? 5
      } : {
        // Linear specific options
        direction: this.options.direction || 'horizontal',
        height: this.options.height || 10,
        cornerRadius: this.options.cornerRadius ?? 5
      }),
      
      // Label configuration
      label: {
        visible: this.options.showLabel !== false,
        formatter: this.options.labelFormatter || (value => {
          // Ensure we return a string value
          const percentage = Math.round(value * 100);
          return `${percentage}%`;
        }),
        style: {
          fontSize: 14,
          fontWeight: 'bold',
          ...this.options.labelStyle
        }
      },
      
      // Animation configuration
      animationAppear: {
        duration: 800,
        easing: 'cubicOut',
        ...this.options.animationAppear
      },
      
      // Common configuration from BaseChart
      ...commonConfig
    };
  }
}

export default ProgressChart; 